// @flow
import React from 'react'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import InputAdornment from '@material-ui/core/InputAdornment'
import InputLabel from '@material-ui/core/InputLabel'
import TextField from '@material-ui/core/TextField'
import Select from '@material-ui/core/Select'
import Stepper from '@material-ui/core/Stepper'
import Step from '@material-ui/core/Step'
import StepLabel from '@material-ui/core/StepLabel'
import StepContent from '@material-ui/core/StepContent'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import CalcStyles from 'catena/er2_styles/calculator'

type PropsType = {
    column: string,
    onCalculate: Function,
    onClose: Function,
    pushRight: boolean,
    schema: {
        properties: {},
    },
    theme: CalcStyles,
    attributes: [],
    rows: [],
}

type StateType = {
    formula: string,
    functionType: string,
}

class QueryBuilder extends React.Component<PropsType, StateType> {
    constructor(props) {
        super(props)


        const queries = ['Placeholder 1', 'Placeholder 2', 'Placeholder 3'] // Do something to load saved queries

        this.state = {
            attributeSelect: '',
            query: '',
            addValue: '',
            current: '',
            fieldValue: '',
            valueSelect: '',
            expected: 'ATTRIBUTE',
            lastLength: 0,
            queryComplete: false,
            activeStep: 0,
            layerDistance: '',
            bufferRadius: '',
            queries,
        }
    }

    handleAttributeSelect = (attribute) => {
        const query = this.state.query
        const current = this.state.current
        const expected = this.state.expected

        if (current === '') {
            this.setState({
                attributeSelect: attribute,
                currentAttribute: attribute,
                current: 'ATTRIBUTE',
                expected: 'OPERATOR',
                query: `"${attribute}"`,
                lastLength: attribute.length + 2,
                valueSelect: '',
            })
        } else if (expected === 'ATTRIBUTE') {
            if (current === 'OPERATOR') {
                this.setState({
                    attributeSelect: attribute,
                    currentAttribute: attribute,
                    current: 'ATTRIBUTE',
                    expected: 'CONJUNCTION',
                    query: `${query} "${attribute}"`,
                    lastLength: attribute.length + 2,
                    valueSelect: '',
                })
            } else if (current === 'CONJUNCTION') {
                this.setState({
                    attributeSelect: attribute,
                    currentAttribute: attribute,
                    current: 'ATTRIBUTE',
                    expected: 'OPERATOR',
                    query: `${query} "${attribute}"`,
                    lastLength: attribute.length + 2,
                    valueSelect: '',
                })
            }
        } else if (current === 'ATTRIBUTE') {
            this.setState({
                attributeSelect: attribute,
                currentAttribute: attribute,
                query: `${query.slice(0, query.length - this.state.lastLength)}"${attribute}"`,
                lastLength: attribute.length + 2,
                valueSelect: '',
            })
        } else {
            this.setState({
                attributeSelect: attribute,
                valueSelect: '',
            })
        }
    }

    handleAddAttribute = () => {
        this.handleAttributeSelect(this.state.attributeSelect)
    }

    handleAddOperator = (operator) => {
        const query = this.state.query
        const current = this.state.current
        const expected = this.state.expected

        if (expected === 'OPERATOR') {
            if (operator.includes('NULL')) {
                this.setState({
                    current: 'OPERATOR',
                    expected: 'CONJUNCTION',
                    query: `${query} ${operator}`,
                    lastLength: operator.length,
                })
            } else {
                this.setState({
                    current: 'OPERATOR',
                    expected: 'VALUE',
                    query: `${query} ${operator}`,
                    lastLength: operator.length,
                })
            }
        } else if (current === 'OPERATOR') {
            if (operator.includes('NULL')) {
                this.setState({
                    current: 'OPERATOR',
                    expected: 'CONJUNCTION',
                    query: `${query.slice(0, query.length - this.state.lastLength)}${operator}`,
                    lastLength: operator.length,
                })
            } else {
                this.setState({
                    current: 'OPERATOR',
                    expected: 'VALUE',
                    query: `${query.slice(0, query.length - this.state.lastLength)}${operator}`,
                    lastLength: operator.length,
                })
            }
            this.setState({
                lastLength: operator.length,
            })
        }
    }

    handleAddConjunction = (conjunction) => {
        const query = this.state.query
        const current = this.state.current
        const expected = this.state.expected

        if (expected === 'CONJUNCTION') {
            this.setState({
                current: 'CONJUNCTION',
                expected: 'ATTRIBUTE',
                query: `${query} ${conjunction}`,
                lastLength: conjunction.length,
            })
        } else if (current === 'CONJUNCTION') {
            this.setState({
                query: `${query.slice(0, query.length - this.state.lastLength)}${conjunction}`,
                lastLength: conjunction.length,
            })
        }
    }

    handleAddValue = (v) => {
        let value = v
        if (v === null && this.state.fieldValue) value = this.state.fieldValue
        if (typeof this.props.rows[0][this.state.currentAttribute] === 'string') {
            value = `'${value}'`
        }
        const query = this.state.query
        const current = this.state.current
        const expected = this.state.expected

        if (expected === 'VALUE') {
            this.setState({
                valueSelect: (v !== null) ? v : this.state.valueSelect,
                current: 'VALUE',
                expected: 'CONJUNCTION',
                query: `${query} ${value}`,
                lastLength: value.length,
            })
        } else if (current === 'VALUE') {
            this.setState({
                valueSelect: (v !== null) ? v : this.state.valueSelect,
                query: `${query.slice(0, query.length - this.state.lastLength)}${value}`,
                lastLength: value.length,
            })
        } else {
            this.setState({
                valueSelect: (v !== null) ? v : this.state.valueSelect,
            })
        }
    }

    handleChangeFieldValue = (e) => {
        this.setState({
            fieldValue: e.target.value,
        })
    }

    handleChangeSpatialLocationType = (e) => {
        this.setState({
            spatialLocationType: e.target.value,
        })
    }

    handleChangeBufferRadius = (e) => {
        if (!isNaN(e.target.value)) {
            this.setState({
                bufferRadius: e.target.value,
            })
        }
    }

    handleQuerySelect = (query) => {
        const loadedQuery = '' // load the saved query
        this.setState({
            querySelect: query,
            query: loadedQuery,
        })
    }

    handleChangeBufferType = (e) => {
        this.setState({
            bufferType: e.target.value,
        })
    }

    handleChangeRelationshipType = (e) => {
        this.setState({
            relationshipType: e.target.value,
        })
    }

    handleChangeRelatedLayer = (e) => {
        this.setState({
            relatedLayer: e.target.value,
        })
    }

    handleChangeLayerDistance = (e) => {
        if (!isNaN(e.target.value)) {
            this.setState({
                layerDistance: e.target.value,
            })
        }
    }

    loadQuery = () => {
        const loadedQuery = '' // load the saved query
        this.setState({
            activeStep: this.getSteps().indexOf('Attribute'),
            query: loadedQuery,
        })
    }

    clearQuery = () => {
        this.setState({
            query: '',
            current: '',
            expected: 'ATTRIBUTE',
        })
    }

    getSteps = () => {
        return ['Select Layer', 'Attribute', 'Spatial Location', 'Run Query']
    }

    getLayerList = () => {
        const layers = [
            'Placeholder 1',
            'Placeholder 2',
            'Placeholder 3',
            'Placeholder 4',
        ]
        return layers.map(l => (
            <MenuItem
                key={l}
                value={l}
            >
                {l}
            </MenuItem>
        ))
    }

    prevStep = () => {
        this.setState({
            activeStep: this.state.activeStep - 1,
        })
    }

    nextStep = () => {
        this.setState({
            activeStep: this.state.activeStep + 1,
        })
    }

    deleteQuery = () => {
        const query = this.state.querySelect
        const qi = this.state.queries.indexOf(query)
        const queries = [
            ...this.state.queries.slice(0, qi),
            ...this.state.queries.slice(qi + 1),
        ]
        this.setState({
            querySelect: '',
            queries,
        })
    }

    newQuery = () => {
        this.setState({
            activeStep: this.getSteps().indexOf('Attribute'),
            query: '',

        })
    }

    runQuery = () => {
        alert('Run Query not implemented')
    }

    saveQuery = () => {
        alert('Save Query not implemented')
    }

    nextButtonIsAvailable = () => {
        return this.state.activeStep > 0 &&
            (this.state.query === '' || this.state.expected === 'CONJUNCTION') &&
            this.state.activeStep < this.getSteps().length - 1
    }


    render() {
        const relationshipTypes = [
            'Intersects',
            'Within a Distance of',
            'Contains',
            'Completely Contains',
            'Within',
            'Completely Within',
            'Identical to',
            'Touches the Boundary of',
            'Shares a Line Segment With',
            'Crossed By',
        ]

        const relationshipTypeList = relationshipTypes.map(t => (
            <MenuItem
                key={t.toLowerCase()}
                value={t.toLowerCase()}
            >
                {t}
            </MenuItem>
        ))

        const attributeList = this.props.attributes.map(attr => (
            <MenuItem
                key={attr}
                value={attr}
            >
                {attr}
            </MenuItem>
        ))

        const sampleValues = this.props.rows
            .map(row => row[this.state.attributeSelect])
            .filter((val, i, array) => val && array.indexOf(val) === i)

        const valueList = sampleValues.map(v => (
            <MenuItem
                key={v}
                value={v}
            >
                {v}
            </MenuItem>
        ))

        const queryList = this.state.queries.map(q => (
            <MenuItem
                key={q}
                value={q}
            >
                {q}
            </MenuItem>
        ))


        return (
            <div
                className={this.props.theme.modelessBox}
                style={{
                    left: (this.props.pushRight ? '435px' : '50px'),
                }}
            >
                <div
                    className={this.props.theme.modelessHeader}
                >
                    Query Builder

                    <IconButton
                        className={this.props.theme.xCloseButton}
                        onClick={this.props.onClose}
                        theme={this.props.theme}
                    >
                        <i className="fa fa-times" />
                    </IconButton>
                </div>
                <Stepper
                    activeStep={this.state.activeStep}
                    orientation="vertical"
                    theme={this.props.theme}
                >
                    <Step key={0} >
                        <StepLabel>Load Query</StepLabel>
                        <StepContent>
                            <table className={this.props.theme.modelessLayoutTable} >
                                <tbody>
                                    <tr>
                                        <td>
                                            <FormControl
                                                className={this.props.theme.dialogSelect}
                                            >
                                                <InputLabel
                                                    shrink={this.state.querySelect}
                                                    htmlFor="query-select"
                                                >Load a Query</InputLabel>
                                                <Select
                                                    autoWidth
                                                    value={this.state.querySelect}
                                                    onChange={e => this.handleQuerySelect(e.target.value)}
                                                    inputProps={{
                                                        name: 'query-select',
                                                        id: 'query-select',
                                                    }}
                                                >
                                                    <MenuItem value="">None</MenuItem>
                                                    {queryList}
                                                </Select>
                                            </FormControl>
                                        </td>
                                        <td>
                                            {this.state.querySelect ? (
                                                <Button
                                                    onClick={this.loadQuery}
                                                >Load Query</Button>
                                            ) : (
                                                <Button
                                                    onClick={this.newQuery}
                                                >New Query</Button>
                                            )}
                                        </td>
                                    </tr>
                                    {this.state.querySelect && [(
                                        <tr>
                                            <td />
                                            <td>
                                                <Button
                                                    onClick={this.deleteQuery}
                                                >Delete Query</Button>
                                            </td>
                                        </tr>), (
                                            <tr>
                                                <td />
                                                <td>
                                                    <Button
                                                        onClick={this.newQuery}
                                                    >New Query</Button>
                                                </td>
                                            </tr>
                                        )]
                                    }
                                </tbody>
                            </table>
                        </StepContent>
                    </Step>
                    <Step key={1}>
                        <StepLabel>Attribute</StepLabel>
                        <StepContent>
                            <table
                                className={this.props.theme.modelessLayoutTable}
                            >
                                <tbody>
                                    <tr>
                                        <td>
                                            <FormControl
                                                className={this.props.theme.dialogSelect}
                                            >
                                                <InputLabel htmlFor="attribute-select">Select an Attribute</InputLabel>
                                                <Select
                                                    autoWidth
                                                    value={this.state.attributeSelect}
                                                    onChange={e => this.handleAttributeSelect(e.target.value)}
                                                    inputProps={{
                                                        name: 'attribute-select',
                                                        id: 'attribute-select',
                                                    }}
                                                >
                                                    {attributeList}
                                                </Select>
                                            </FormControl>
                                        </td>
                                        <td>
                                            <Button
                                                onClick={this.handleAddAttribute}
                                            >
                                                Add to Query
                                            </Button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan="2">
                                            Operations:
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <IconButton
                                                onClick={() => this.handleAddOperator('=')}
                                            >{'='}</IconButton>
                                            <IconButton
                                                onClick={() => this.handleAddOperator('<>')}
                                            >{'<>'}</IconButton>
                                            <IconButton
                                                onClick={() => this.handleAddOperator('>')}
                                            >{'>'}</IconButton>
                                            <IconButton
                                                onClick={() => this.handleAddOperator('<')}
                                            >{'<'}</IconButton>
                                            <IconButton
                                                onClick={() => this.handleAddOperator('>=')}
                                            >{'>='}</IconButton>
                                            <IconButton
                                                onClick={() => this.handleAddOperator('<=')}
                                            >{'<='}</IconButton>
                                            <Button
                                                onClick={() => this.handleAddOperator('IS NULL')}
                                            >IS NULL</Button>
                                            <Button
                                                onClick={() => this.handleAddOperator('IS NOT NULL')}
                                            >IS NOT NULL</Button>
                                        </td>
                                        <td>
                                            <Button
                                                onClick={() => this.handleAddConjunction('And')}
                                            >And</Button>
                                            <Button
                                                onClick={() => this.handleAddConjunction('Or')}
                                            >Or</Button>
                                            <Button
                                                onClick={() => this.handleAddOperator('Like')}
                                            >Like</Button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan="2">
                                            Attribute Values:
                                        </td>
                                    </tr>
                                    <tr>
                                        <td />
                                        <td>
                                            <TextField
                                                label="Value"
                                                value={this.state.fieldValue}
                                                onChange={this.handleChangeFieldValue}
                                            />
                                        </td>
                                        <td>
                                            <Button
                                                onClick={() => this.handleAddValue(null)}
                                            >
                                                Add
                                            </Button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td />
                                        <td colSpan="2">
                                            <FormControl
                                                className={this.props.theme.dialogSelect}
                                            >
                                                <InputLabel htmlFor="sample-values">
                                                    Sample Values
                                                </InputLabel>
                                                <Select
                                                    className={this.props.theme.dialogSelect}
                                                    value={this.state.valueSelect}
                                                    onChange={e => this.handleAddValue(e.target.value)}
                                                >
                                                    {valueList}
                                                </Select>
                                            </FormControl>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan="2">
                                            <TextField
                                                label="Query"
                                                multiline
                                                readOnly
                                                rows="3"
                                                value={this.state.query}
                                                className={this.props.theme.dialogTextArea}
                                            />
                                        </td>
                                        <td />
                                    </tr>
                                    <tr>
                                        <td colSpan="2" />
                                        <td>
                                            <Button
                                                onClick={this.clearQuery}
                                            >
                                                Clear
                                            </Button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </StepContent>
                    </Step>
                    <Step key={2}>
                        <StepLabel>Spatial Location</StepLabel>
                        <StepContent>
                            <table className={this.props.theme.modelessLayoutTable} >
                                <tbody>
                                    <tr>
                                        <td colSpan="2">
                                            <FormControl
                                                className={this.props.theme.dialogSelect}
                                            >
                                                <InputLabel
                                                    shrink={this.state.spatialLocationType}
                                                    htmlFor="sample-values"
                                                >
                                                    Spatial Location Type
                                                </InputLabel>
                                                <Select
                                                    className={this.props.theme.dialogSelect}
                                                    value={this.state.spatialLocationType}
                                                    onChange={this.handleChangeSpatialLocationType}
                                                >
                                                    <MenuItem value="">Empty</MenuItem>
                                                    <MenuItem value="selection">By Selection</MenuItem>
                                                    <MenuItem value="relationship">By Relationship</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </td>
                                    </tr>
                                    { this.state.spatialLocationType === 'selection' && [
                                        <tr colSpan="2">
                                            <td>
                                                <TextField
                                                    label="Buffer Radius"
                                                    value={this.state.bufferRadius}
                                                    onChange={this.handleChangeBufferRadius}
                                                    InputProps={{
                                                        endAdornment: <InputAdornment position="end">mi</InputAdornment>,
                                                    }}
                                                />
                                            </td>
                                        </tr>,
                                        <tr colSpan="2">
                                            <td>
                                                <FormControl component="fieldset">
                                                    <RadioGroup
                                                        aria-label="BufferType"
                                                        name="bufferType"
                                                        value={this.state.bufferType}
                                                        onChange={this.handleChangeBufferType}
                                                    >
                                                        <FormControlLabel
                                                            value="point"
                                                            control={
                                                                <Radio
                                                                    className={this.props.theme.radio}
                                                                />
                                                            }
                                                            label="Point Buffer  "
                                                            labelPlacement="start"
                                                            theme={this.props.theme}
                                                        />
                                                        <FormControlLabel
                                                            value="line"
                                                            control={
                                                                <Radio
                                                                    className={this.props.theme.radio}
                                                                />
                                                            }
                                                            label="Line Buffer  "
                                                            labelPlacement="start"
                                                            theme={this.props.theme}
                                                        />
                                                        <FormControlLabel
                                                            value="polygon"
                                                            control={
                                                                <Radio
                                                                    className={this.props.theme.radio}
                                                                />
                                                            }
                                                            label="Polygon  "
                                                            labelPlacement="start"
                                                            theme={this.props.theme}
                                                        />
                                                    </RadioGroup>
                                                </FormControl>
                                            </td>
                                        </tr>,
                                    ]}
                                    { this.state.spatialLocationType === 'relationship' && [
                                        <tr>
                                            <td colSpan="2">
                                                <FormControl>
                                                    <InputLabel
                                                        shrink={this.state.relationshipType}
                                                        htmlFor="relationship-types"
                                                    >
                                                        Relationship Type
                                                    </InputLabel>
                                                    <Select
                                                        id="relationship-types"
                                                        className={this.props.theme.dialogSelect}
                                                        value={this.state.relationshipType}
                                                        onChange={this.handleChangeRelationshipType}
                                                    >
                                                        {relationshipTypeList}
                                                    </Select>
                                                </FormControl>
                                            </td>
                                        </tr>,
                                        <tr>
                                            <td colSpan="2">
                                                <FormControl>
                                                    <InputLabel
                                                        shrink={this.state.relatedLayer}
                                                        htmlFor="layers"
                                                    >
                                                        Layer
                                                    </InputLabel>
                                                    <Select
                                                        id="layers"
                                                        className={this.props.theme.dialogSelect}
                                                        value={this.state.relatedLayer}
                                                        onChange={this.handleChangeRelatedLayer}
                                                    >
                                                        {this.getLayerList()}
                                                    </Select>
                                                </FormControl>
                                            </td>
                                        </tr>,
                                        this.state.relationshipType === 'within a distance of' && (
                                            (
                                                <tr>
                                                    <td colSpan="2">
                                                        <TextField
                                                            label="Distance"
                                                            value={this.state.layerDistance}
                                                            onChange={this.handleChangeLayerDistance}
                                                            InputProps={{
                                                                endAdornment: <InputAdornment position="end">mi</InputAdornment>,
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            )
                                        ),
                                    ]}
                                </tbody>
                            </table>
                        </StepContent>
                    </Step>
                    <Step key={3}>
                        <StepLabel>Run Query</StepLabel>
                        <StepContent>
                            <table
                                className={this.props.theme.modelessLayoutTable}
                            >
                                <tr>
                                    <td>
                                        <Button
                                            onClick={this.runQuery}
                                        >Run Query</Button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <Button
                                            onClick={this.saveQuery}
                                        >Save Query</Button>
                                    </td>
                                </tr>
                            </table>
                        </StepContent>
                    </Step>
                </Stepper>
                {this.state.activeStep > 0 && (
                    <Button
                        className={this.props.theme.modelessButtonLeft}
                        onClick={this.prevStep}
                        variant="contained"
                    >
                        Previous
                    </Button>
                )}
                {this.nextButtonIsAvailable() && (
                    <Button
                        className={this.props.theme.modelessButtonRight}
                        onClick={this.nextStep}
                        variant="contained"
                    >
                        Next
                    </Button>
                )}
            </div>
        )
    }
}

export default QueryBuilder
